import { useRevenueByTypeTotal } from "@gymflow/api";
import { DATE_FORMAT, PARAMETER_DATE_FORMAT_WITHOUT_TZ } from "@gymflow/common";
import { formatCurrency } from "@gymflow/helpers";
import { useClubSettings } from "apps/portal/src/providers";
import useGymflowModels from "apps/portal/src/store";
import moment from "moment";
import QueryString from "qs";
import { useContext } from "react";
import { useHistory } from "react-router";

import { usePortalRoutes } from "../../../../../hooks/usePortalRoutes";
import { RouteFeature } from "../../../../../routes/feature";
import { RouteLayout } from "../../../../../routes/layout";
import ReportWidgetCard from "../../../../ReportWidgetCard/ReportWidgetCard";
import { ReportContext } from "../../../ReportContext";

export const ReportRevenueOtherAccountReceivableWidget = ({
  parentRoute,
}: {
  parentRoute: string;
}) => {
  const { createClubLink } = usePortalRoutes();
  const history = useHistory();
  const { api } = useGymflowModels();

  const { club } = useClubSettings();

  const data = useContext(ReportContext);

  const { data: dataTotal, isFetching } = useRevenueByTypeTotal({
    api,
    dateFrom: data.startDate
      ? moment(data.startDate, DATE_FORMAT).format(
          PARAMETER_DATE_FORMAT_WITHOUT_TZ,
        )
      : undefined,
    dateTo: data.endDate
      ? moment(data.endDate, DATE_FORMAT)
          .endOf("day")
          .format(PARAMETER_DATE_FORMAT_WITHOUT_TZ)
      : undefined,
    revenueType: "accounts-receivable",
    tz: club.timezone,
  });

  return (
    <ReportWidgetCard
      title="Accounts Receivable"
      value={formatCurrency(
        Math.round(dataTotal === undefined ? 0 : dataTotal.total),
        club.defaultCurrency,
        true,
      )}
      isLoading={isFetching}
      explanation="Sum of all invoices that are past due."
      onClick={() =>
        history.push({
          pathname: createClubLink(
            RouteLayout.Staff,
            RouteFeature.RevenueAccountReceivable,
          ),
          search: QueryString.stringify({
            dates: {
              startDate: moment(data.startDate, DATE_FORMAT).format(
                PARAMETER_DATE_FORMAT_WITHOUT_TZ,
              ),
              endDate: moment(data.endDate, DATE_FORMAT)
                .endOf("day")
                .format(PARAMETER_DATE_FORMAT_WITHOUT_TZ),
            },
            backRoute: parentRoute,
          }),
        })
      }
    />
  );
};
